import React from 'react';
import {
  SKELETON_SIDEBAR_ITEM_COUNT,
  SKELETON_STAGGER_DELAY_MS,
} from '@/constants/ui.constants';

/**
 * Lightweight skeleton for reVeal page lazy-load fallback.
 * Mimics the reVeal layout (sidebar + main area) without blocking the full UI.
 */

const RevealPageSkeleton: React.FC = () => {
  return (
    <div className='flex h-full bg-background dark:bg-background-dark text-foreground dark:text-foreground-dark theme-transition'>
      {/* Left sidebar placeholder */}
      <div className='w-64 border-r border-border flex flex-col'>
        <div className='p-4 border-b border-border'>
          <div className='h-6 w-32 rounded bg-muted animate-pulse' />
        </div>
        <div className='flex-1 p-2 space-y-2'>
          {Array.from({ length: SKELETON_SIDEBAR_ITEM_COUNT }, (_, i) => i + 1).map((i) => (
            <div
              key={i}
              className='h-14 rounded-lg bg-muted animate-pulse'
              style={{ animationDelay: `${i * SKELETON_STAGGER_DELAY_MS}ms` }}
            />
          ))}
        </div>
      </div>

      {/* Main content placeholder — max-width matches --thread-max-width CSS variable */}
      <div className='flex-1 flex flex-col items-center px-4 py-8'>
        <div className='w-full max-w-[var(--thread-max-width)] space-y-4'>
          <div className='h-4 w-3/4 rounded bg-muted animate-pulse' />
          <div className='h-4 w-1/2 rounded bg-muted animate-pulse' />
          <div className='h-4 w-5/6 rounded bg-muted animate-pulse' />
          <div className='mt-8 h-12 w-full rounded-lg bg-muted animate-pulse' />
        </div>
      </div>
    </div>
  );
};

export default RevealPageSkeleton;
